import styles from "./SchedulePage.module.scss";
import appointmentImage from "../../assets/images/schedule/appointment.png";
import arrowRight2 from "../../assets/images/icons/arrow-right-2.svg";
import CustomButton from "../../components/UI/CustomButton/CustomButton";
import { useTranslation } from "react-i18next";
import { useState } from "react";
import BookAppointment from "./BookAppointment/BookAppointment";
import useAppSelector from "../../hooks/useAppSelector";
import useAppDispatch from "../../hooks/useAppDispatch";
import { openLoginPopup } from "../../store/notification/notificationSlice";
import moment from "moment";
import DaySelect from "../../components/DaySelect/DaySelect";
import { getImageFromAuthServer, getTrainerImage } from "../../helpers/image.helper";
import ScheduleClasses from "./ScheduleClasses/ScheduleClasses";
import {useQuery} from "../../hooks/useQuery";
import StripeElements from "../../components/StripeElements/StripeElements";
import Check3DSecurePayment from "../../components/Check3DSecurePayment/Check3DSecurePayment";

const SchedulePage = () => {
    const query = useQuery();
    const [paymentIntentId] = useState(query.get("payment_intent_client_secret"));
    const dispatch = useAppDispatch();
    const { t } = useTranslation();
    const { isAuthorized } = useAppSelector(state => state.profileSlice);
    const { classes } = useAppSelector(state => state.classesSlice);
    const { trainers } = useAppSelector(state => state.trainersSlice);
    const {activeGym} = useAppSelector(state => state.multiGymsSlice);

    const [numberForWeek, setNumberForWeer] = useState<number>(0);
    const dateArray = [
        moment().add(numberForWeek, "days").format(),
        moment().add(1 + numberForWeek, "days").format(),
        moment().add(2 + numberForWeek, "days").format(),
        moment().add(3 + numberForWeek, "days").format(),
        moment().add(4 + numberForWeek, "days").format(),
        moment().add(5 + numberForWeek, "days").format(),
        moment().add(6 + numberForWeek, "days").format()
    ];
    const [currentDate, setCurrentDate] = useState<string>(dateArray[0]);
    const [selectedClasses, setSelectedClasses] = useState<number[]>([]);
    const [selectedTrainers, setSelectedTrainers] = useState<number[]>([]);

    const [showAppointment, setShowAppointment] = useState<boolean>(false);

    const openAppointmentPopup = () => {
        if (isAuthorized) {
            setShowAppointment(true);
        } else {
            dispatch(openLoginPopup({ isOpen: true }));
        }

    }

    const clickOnClassItem = (classId: number) => {
        if (checkIsClassSelected(classId)) {
            const filteredClasses = selectedClasses.filter(el => el !== classId);
            setSelectedClasses(filteredClasses);
        } else {
            setSelectedClasses([...selectedClasses, classId]);
        }
    }

    const checkIsClassSelected = (classId: number) => {
        if (!selectedClasses.length) return false;
        return selectedClasses.includes(classId);
    }

    const clickOnTrainerItem = (instructorId: number) => {
        if (checkIsTrainerSelected(instructorId)) {
            const filteredInstructors = selectedTrainers.filter(el => el !== instructorId);
            setSelectedTrainers(filteredInstructors);
        } else {
            setSelectedTrainers([...selectedTrainers, instructorId]);
        }
    }

    const checkIsTrainerSelected = (instructorId: number) => {
        if (!selectedTrainers.length) return false;
        return selectedTrainers.includes(instructorId);
    }

    const closeAppointmentPopup = () => {
        setShowAppointment(false);
    }

    return (
        <div className={styles.page}>
            <section>
                <div className={"container"}>
                    <div className={styles.appointment}>
                        <img className={styles.image} src={appointmentImage} alt="Appointment" />
                        <div className={styles.info}>
                            <h2 className={styles.title}>{t("BookAnAppointment")}</h2>
                            <p className={styles.text}>{t("TakeTheFirstStepTowardAchievingYourFitnessGoalsByBookingAPersonalizedSessionToday")}</p>
                            <div className={styles.btnWrapper}>
                                <CustomButton
                                    text={t("BookAnAppointment")}
                                    type={"button"}
                                    typeStyle={"fill"}
                                    borderRadius={false}
                                    functionOnClick={openAppointmentPopup}
                                    iconPath={arrowRight2}
                                    altIcon={"arrow"}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section>
                <div className={styles.groupClasses}>
                    <div className={"container"}>
                        <h2 className={styles.title}>{t("GroupClasses")}</h2>
                        <DaySelect
                            dateArray={dateArray}
                            currentDate={currentDate}
                            setCurrentDate={setCurrentDate}
                            setNumberForWeer={setNumberForWeer}
                            numberForWeek={numberForWeek}
                            forEventCalendar={true}
                        />
                    </div>
                    <div className={styles.selectsContainer}>
                        <div className={"container"}>
                            <div className={styles.wrapper}>
                                {
                                    classes.map(el => {
                                        return (
                                            <div onClick={() => clickOnClassItem(el.id)}
                                                className={`${styles.item} ${checkIsClassSelected(el.id) && styles.active}`}
                                                key={el.id}
                                                style={{ backgroundImage: `url(${getImageFromAuthServer(el.image)})` }}>
                                                <p className={styles.name}>{el.name}</p>
                                            </div>
                                        )
                                    })
                                }
                            </div>

                            <div className={styles.wrapper}>
                                {
                                    trainers.map(el => {
                                        return (
                                            <div onClick={() => clickOnTrainerItem(el.id)}
                                                className={`${styles.item} ${checkIsTrainerSelected(el.id) && styles.active}`}
                                                key={el.id}
                                                style={{ backgroundImage: `url(${getTrainerImage(activeGym.endpoint, el)})` }}>
                                                <p className={styles.name}>{el.firstname} {el.lastname}</p>
                                            </div>
                                        )
                                    })
                                }
                            </div>
                        </div>
                    </div>
                    <div className={"container"}>
                        <ScheduleClasses
                            currentDate={currentDate}
                            selectedTrainers={selectedTrainers}
                            selectedClasses={selectedClasses}
                        />
                    </div>
                </div>
            </section>
            {
                showAppointment && isAuthorized && (
                    <BookAppointment
                        closeAppointmentPopup={closeAppointmentPopup}
                    />
                )
            }
            {
                paymentIntentId && (
                    <StripeElements>
                        <Check3DSecurePayment
                            fromUrl={"/schedule"}
                            paymentIntentId={paymentIntentId}
                        />
                    </StripeElements>
                )
            }
        </div>
    )
}

export default SchedulePage;